import { render, staticRenderFns } from "./bookingInfoCard.vue?vue&type=template&id=7611120e"
import script from "./bookingInfoCard.vue?vue&type=script&lang=js"
export * from "./bookingInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports